import { faCalendarXmark } from "@fortawesome/duotone-light-svg-icons"
import { Button, SessionBillingPeriod } from "@joonapp/web-shared"
import { SessionBooking } from "@joonapp/web-shared"

import useUserRole from "../../../../hooks/useUserRole"
import useSession from "../hooks/useSession"

const ScheduleMakeupButton = ({
  session,
  billingPeriod,
}: {
  session: SessionBooking
  billingPeriod: SessionBillingPeriod
}) => {
  const { handleScheduleMakeUp, showScheduleMakeUpButton } = useSession(session)
  const { isClientOfOtherCoach } = useUserRole()

  if (!showScheduleMakeUpButton || !billingPeriod) return <></>

  return (
    <Button
      text="Schedule makeup"
      buttonType="secondary"
      onClick={() => handleScheduleMakeUp(billingPeriod)}
      icon={faCalendarXmark}
      disabled={isClientOfOtherCoach}
    />
  )
}

export default ScheduleMakeupButton
